module.exports = __webpack_public_path__ + "img/shop-by-suv.75c7f6a2.png";